import { Routes, Route } from "react-router-dom";
import { NotFound } from "../components/common";
import Home from "../pages/Course/Home";
import Detail from "../pages/Course/Detail";

const Course = () => {
  return (
    <div className="Course">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:id" element={<Detail />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Course;
